import { BaseDocumentId, customNanoId } from "../base-document-id";
import type {
	DocumentGenerationVersion,
	DocumentHistoryVersion,
	DocumentUniqueId,
} from "../types";

export class WhiteboardDocumentId extends BaseDocumentId {
	constructor(
		id?: DocumentUniqueId,
		generationVersion?: DocumentGenerationVersion,
		historyVersion?: DocumentHistoryVersion,
	) {
		super(
			"whiteboard",
			id ?? customNanoId(),
			generationVersion,
			historyVersion,
		);
	}

	atGenerationVersion(generationVersion: DocumentGenerationVersion) {
		return new WhiteboardDocumentId(
			this.id,
			generationVersion,
			this.historyVersion,
		);
	}

	atHistoryVersion(historyVersion: DocumentHistoryVersion) {
		return new WhiteboardDocumentId(
			this.id,
			this.generationVersion,
			historyVersion,
		);
	}
}
